import { render } from "./ExampleDeviceScreenPdf.vue?vue&type=template&id=62f79e98&scoped=true&lang=pug"
const script = {}

import "./ExampleDeviceScreenPdf.vue?vue&type=style&index=0&id=62f79e98&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f79e98"]])

export default __exports__